// extracted by mini-css-extract-plugin
module.exports = {"label":"_32bbee5fda--label--fCs_v","cursor_pointer":"_32bbee5fda--cursor_pointer--i71ok"};